module.exports = new __parcel__URL__("help-page-header.2e36223e.jpg").toString();